import React from 'react';
import SharedPageLayout from '../components/SharedPageLayout';
import { termsOfService, shippingReturns, licensingPolicy, privacyPolicy } from '../data/policies';

export const TermsOfServiceRoute = () => {
  return (
    <SharedPageLayout currentPage="terms-of-service">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-slate max-w-none">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms of Service</h1>
          <p className="text-slate-600 mb-8">Last updated: January 2025</p>
          <div dangerouslySetInnerHTML={{ __html: termsOfService }} />
        </div>
      </div>
    </SharedPageLayout>
  );
};

export const ShippingReturnsRoute = () => {
  return (
    <SharedPageLayout currentPage="shipping-returns">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-slate max-w-none">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Shipping & Returns</h1>
          <p className="text-slate-600 mb-8">Last updated: January 2025</p>
          <div dangerouslySetInnerHTML={{ __html: shippingReturns }} />
        </div>
      </div>
    </SharedPageLayout>
  );
};

export const LicensingPolicyRoute = () => {
  return (
    <SharedPageLayout currentPage="licensing-policy">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-slate max-w-none">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Licensing Policy</h1>
          <p className="text-slate-600 mb-8">Last updated: January 2025</p>
          <div dangerouslySetInnerHTML={{ __html: licensingPolicy }} />
        </div>
      </div>
    </SharedPageLayout>
  );
};

export const PrivacyPolicyRoute = () => {
  return (
    <SharedPageLayout currentPage="privacy-policy">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-slate max-w-none">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Privacy Policy</h1>
          <p className="text-slate-600 mb-8">Last updated: January 2025</p>
          <div dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
        </div>
      </div>
    </SharedPageLayout>
  );
};
